export default __webpack_public_path__ + "static/media/affiliate-man.cca9870c.png";